import gql from 'graphql-tag';
export default gql`
  query products($orgId: String!) {
    products(orgId: $orgId) {
      id
      name
    }
  }
`;
